module.exports = __webpack_public_path__ + "img/lg_ring_r_i_0_1@3x.ea60e506.png";